import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { TriggerTarget } from '../interactions/triggerTarget.js';
import { wlUtils } from '@sorskoot/wonderland-components';

/**
 * Component to toggle the active state of a target object when the trigger is activated.
 * The target object will be activated or deactivated based on the `activateObject` property.
 */
export class ActivateObject extends Component {
    static TypeName = 'activate-object';
    private _triggerTarget?: TriggerTarget | null;

    @property.object({ required: true })
    targetObject!: Object3D;

    @property.bool(true)
    activateObject = true;

    start(): void {
        this._triggerTarget = this.object.getComponent(TriggerTarget)!;
        // Ensure the target object is active based on the initial state
        wlUtils.setActive(this.targetObject, !this.activateObject);
    }

    onActivate(): void {
        this._triggerTarget?.onExecute.add(this._onExecute);
    }

    onDeactivate(): void {
        this._triggerTarget?.onExecute.remove(this._onExecute);
    }

    private _onExecute = () => {
        wlUtils.setActive(this.targetObject, this.activateObject);
    };
}
